module.exports = "/_next/static/images/343ef8aea7f8e64bd20fb59dbab2329e-device-frame-dark@0.5x.png";